import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { ProductEntity } from "src/app/features/Product/types/ProductEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import {
    productItemTypeSelectorConfig,
    productTypeSelectorConfig,
    statusSelectorConfig,
} from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const ProductSearchForm: FC<SearchFormProps<ProductEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("product.shortName")} name="shortName">
                <TextInput name="shortName" />
            </Form.Item>
            <Form.Item label={t("product.code")} name="grCode">
                <TextInput name="grCode" />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("product.itemType")} name="itemType">
                <SelectDynamic name="itemType" label={t("form.itemType")} fieldConfig={productItemTypeSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("form.type")} name="type">
                <SelectDynamic name="type" label={t("form.type")} fieldConfig={productTypeSelectorConfig} />
            </Form.Item>
        </SearchForm>
    );
};
